// extracted by mini-css-extract-plugin
module.exports = {"sensorIconAndTextGrouping":"ValueChip_sensorIconAndTextGrouping__3hV3Z","sensorTypeText":"ValueChip_sensorTypeText__3JLZJ","secondaryText":"ValueChip_secondaryText__22RS1"};